<template>
  <div class="container">
    <div class="content">
      <ul
        class="items"
        :style="listStyle"
      >
        <li
          v-for="(item, key) in items"
          :key="key"
          class="item"
          :class="{ animating: animatings[key] }"
          :style="{ ...itemStyle, transform: `translatex(${translates[key]}px)` }"
        >
          <img
            v-if="item.type === 'image'"
            class="item-img"
            :src="item.url"
            :alt="item.name"
            style="height: 100%;"
          >
          <div
            v-if="item.type === 'video' /* && /\.mp4$/i.test(item.name) */ || item.type === 'audio'"
            class="item-video-wrapper"
          >
            <!-- <video
              class="item-video"
              :class="{ audio: item.type === 'audio' }"
              :src="item.url"
              :alt="item.name"
              :poster="item.cover"
              style="width: 100%;height: 100%;"
              :controls="showControls"
              controlslist="nodownload"
              disablepictureinpicture
              @mouseenter="onMEVideo"
              @mouseleave="onMLVideo"
              @play="playing = true"
              @pause="playing = false"
              @ended="playing = false"
            ></video>-->
            <player
              ref="player"
              :style="{ height: '100%' }"
              :src="item.url"
              :poster="item.cover"
              :class="{ audio: item.type === 'audio' }"
              :bg-transparent="item.type === 'audio'"
              @play="playing = true"
              @pause="playing = false"
              @atEnded="playing = false"
              @noSupportedSource="noSupportedSource"
            ></player>
            <div
              v-if="false"
              v-show="!playing"
              class="item-video-btn"
              @click="play"
            >
              <iconfont
                name="#icon11-11zantingbofanganniu"
                font-size="16px"
              ></iconfont>
            </div>
          </div>
          <!-- <div
            v-if="item.type === 'video' && !/\.mp4$/i.test(item.name)"
            class="item-video-unsupport"
            :style="{ backgroundImage: `url(${item.cover})` }"
          >
            <div class="icon-wrapper">
              <iconfont
                name="#icon13-5wufayulan"
                font-size="34px"
              ></iconfont>
            </div>
            <div class="text">
              该格式暂不支持预览
            </div>
          </div>-->
        </li>
      </ul>
    </div>
    <div class="footer">
      <span
        v-if="items.length > 1"
        class="prev circle-btn"
        @click="throttledArrowClick(activeIndex - 1)"
      >
        <iconfont name="#icon10-62zuobiananniu"></iconfont>
      </span>
      <div class="info">
        <span class="file-counting">{{ getTitleText(activeItem || {}) }}文件({{ activeIndex + 1 || 1 }}/{{ items.length || 1 }})</span>
        <span style="margin-left: 6px;margin-right: 6px;">-</span>
        <!-- <el-tooltip
          effect="dark"
          :content="(activeItem.name || '').replace(/\..+$/, (m) => m.toUpperCase())"
          placement="top"
        >
          <span class="file-name">{{ (activeItem.name || '').replace(/\..+$/, (m) => m.toUpperCase()) }}</span>
        </el-tooltip> -->
        <text-show-tip
          :text="(activeItem.name || '').replace(/\..+$/, (m) => m.toUpperCase())"
          :css-object="{ maxWidth: '118px', textAlign: 'center', width: 'auto', 'margin-right': '1em' }"
        ></text-show-tip>
        <span
          v-if="activeItem.size"
          class="file-size"
        >{{ (activeItem.size / 1024 / 1024).toFixed(2) - 0 }}M</span>
      </div>
      <span
        v-if="items.length > 1"
        class="next circle-btn"
        @click="throttledArrowClick(activeIndex + 1)"
      >
        <iconfont name="#icon10-61youbiananniu"></iconfont>
      </span>
    </div>
  </div>
</template>

<script>
import throttle from 'throttle-debounce/throttle';
import player from '@/components/common/player/player.vue';
import TextShowTip from '@/components/common/textShowTip.vue';
export default {
  components: {
    player,
    TextShowTip
  },
  data() {
    return {
      items: [{ text: 1 }, { text: 2 }, { text: 3 }, { text: 4 }, { text: 5 }],
      animatings: [],
      translates: [],
      itemSize: 480,
      activeIndex: 0,
      playing: false,
      showControls: false
    };
  },
  computed: {
    listStyle() {
      return {
        width: `${this.itemSize}px`
      };
    },
    itemStyle() {
      return {
        width: `${this.itemSize}px`
      };
    },
    activeItem() {
      return this.items[this.activeIndex];
    }
  },
  watch: {
    activeIndex(val, oldVal) {
      if (val !== oldVal) {
        let list = this.$refs.player;
        if (list) {
          let player = list[oldVal];
          if (player && player.playingComputed) {
            player.atPlayPause();
          }
        }
      }
    }
  },
  created() {
    this.items = this.$parent.$parent.getItems();
    this.setTranslate(0);
    this.throttledArrowClick = throttle(300, true, (index) => {
      this.setTranslate(index);
    });
  },
  beforeDestroy() {
    this.items.forEach((item) => {
      URL.revokeObjectURL(item.type === 'image' ? item.url : item.cover);
    });
  },
  methods: {
    initSize() {
      this.itemSize = 480;
    },
    setTranslate(newIndex) {
      let oldIndex = this.activeIndex;
      let endIndex = this.items.length - 1;
      if (newIndex < 0) {
        newIndex = endIndex;
      }
      if (newIndex > endIndex) {
        newIndex = 0;
      }
      let animatings = [];
      let translates = [];
      this.items.forEach((item, i) => {
        let { animating, offset } = this.translateItem(i, newIndex, oldIndex);
        animatings[i] = animating;
        translates[i] = offset;
      });
      this.animatings = animatings;
      this.$nextTick(() => {
        this.translates = translates;
      });
      this.activeIndex = newIndex;
    },
    translateItem(index, newIndex, oldIndex) {
      let length = this.items.length;
      let animating = index === newIndex || index === oldIndex;
      if (length > 2) {
        index = this.processIndex(index, newIndex, length);
      }
      let offset = (index - newIndex) * this.itemSize;
      return {
        animating,
        offset
      };
    },
    processIndex(index, activeIndex, length) {
      if (activeIndex === 0 && index === length - 1) {
        return -1;
      } else if (activeIndex === length - 1 && index === 0) {
        return length;
      } else if (index < activeIndex - 1 && activeIndex - index >= length / 2) {
        return length + 1;
      } else if (index > activeIndex + 1 && index - activeIndex >= length / 2) {
        return -2;
      }
      return index;
    },
    play() {
      let videoEls = this.$el.querySelectorAll('video.item-video') || [];
      videoEls[this.activeIndex] && videoEls[this.activeIndex].play();
      this.playing = true;
    },
    onMEVideo() {
      this.showControls = true;
    },
    onMLVideo() {
      this.showControls = false;
    },
    getTitleText(item) {
      let map = {
        image: '图片',
        video: '视频',
        audio: '音频'
      };
      return map[item.type];
    },
    noSupportedSource() {
      this.$message({
        message: '浏览器不支持该格式的视频预览哦，请下载查看',
        type: 'error',
        center: true
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  // background-color: #fff;
}
.content {
  height: 270px;
  overflow: hidden;
  // background-color: #f2f4f8;
  & > ul {
    display: flex;
    justify-content: center;
  }
}
.items {
  position: relative;
}
.item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 270px;
  flex-shrink: 0;
  background: #f2f4f8;
  &.item.animating {
    transition: transform 0.3s ease-in-out;
  }
}
.header {
  margin-bottom: 30px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 12px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  background-color: #fff;
}
.info {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 266px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.circle-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background: #f6f7fb;
  opacity: 0.8;
  border-radius: 50%;
  cursor: pointer;
  user-select: none;
}
.file-counting {
  white-space: nowrap;
}
.file-name {
  text-align: left;
  margin-right: 10px;
  max-width: 118px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 1.5;
}
.item-img {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 0;
  margin: auto;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
.item-video-wrapper {
  width: 100%;
  height: 100%;
}
.item-video {
  background-color: transparent;
  &.audio {
    background-image: url(../../../assets/audio/item-audio.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
}
.vue-video-player.audio {
  background-image: url(../../../assets/audio/item-audio.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.item-video-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50px;
  height: 50px;
  background: #ffffff;
  opacity: 0.8;
  border-radius: 50%;
  cursor: pointer;
}
.item-video-unsupport {
  width: 100%;
  height: 100%;
  // background-color: #5383fd;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
  & > .text {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fff;
    margin-top: 13px;
  }
}
video::-webkit-media-controls-panel {
  background-color: transparent;
}
</style>
